import Vue from 'vue'
import Router from 'vue-router'
import pc_Popup from '@/components/pc_Popup'
import pc from '@/components/pc'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/pc_Popup',
      name: 'pc_Popup',
      component: pc_Popup
    },
    {
      path: '/',
      name: 'pc',
      component: pc
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js